export default function SideBardLoader() {
  const bgColor = "bg-white animate-pulse";
  return (
    <div className="px-4  flex flex-col gap-4 h-full ">
      <div className={`w-full h-20 rounded-md ${bgColor}`} />

      <section className="flex flex-col gap-2  h-[calc(100vh-140px)]">
        {new Array(10).fill(0).map((_, idx) => (
          <div
            key={String(_ + idx)}
            className={`w-full h-10 rounded-md ${bgColor}`}
          />
        ))}
      </section>

      <div className={`w-full h-20 rounded-md ${bgColor}`} />
    </div>
  );
}
